import { reactive } from 'vue'

export function useLocationDialog () {
  const state = reactive({
    isOpen: false,
    editId: null,
    title: ''
  })

  const open = (config) => {
    const { editId, title } = config || {}
    state.editId = editId
    state.title = title || ''
    state.isOpen = true
  }

  const close = () => {
    state.editId = null
    state.title = ''
    state.isOpen = false
  }

  return {
    state,
    open,
    close
  }
}
